import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-custom-window": "",
  class: "flex flex-wrap items-end gap-4"
}
const _hoisted_2 = { class: "flex flex-wrap items-end gap-4" }

import { computed, ref } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import TextWithHint from '@/components/neue/wizard/TextWithHint.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  ARRIVAL_PRESETS,
  DROP_HINT_LABEL,
  MAX_PRODUCTION_DAYS_BEFORE,
  PRODUCTION_NOTE,
  PRODUCTION_OPTIONS,
  QUARTER_HOURS,
  sectionCopy
} from '@/config/fulfillmentWizardSteps'
import { formatClock } from '@/helpers/dropWizardDates'
import { dropExplainer } from '@/helpers/fulfillmentWizardSchedule'

const EARLIER_MIN = 2


export default {
  __name: 'StepTimes',
  setup(__props) {

const wizard = injectWizard()
const schedule = computed(() => wizard.data.schedule)
const arrival = computed(() => schedule.value.arrival)
const dropHint = computed(() => dropExplainer(wizard))
const windowCopy = computed(() => sectionCopy('window', wizard.data))

const presetOptions = ARRIVAL_PRESETS.map(p => ({
  value: p.value,
  name: p.start ? `${p.label} · ${formatClock(p.start)} to ${formatClock(p.end)}` : p.label
}))
const pickPreset = value => {
  const preset = ARRIVAL_PRESETS.find(p => p.value === value)
  arrival.value.preset = value
  if (preset.start) {
    arrival.value.start = preset.start
    arrival.value.end = preset.end
  }
}

const modeFor = days => (days >= EARLIER_MIN ? 'earlier' : days)
const productionMode = ref(modeFor(schedule.value.productionDaysBefore))
const pickProduction = value => {
  productionMode.value = value
  schedule.value.productionDaysBefore =
    value === 'earlier' ? Math.max(schedule.value.productionDaysBefore ?? 0, EARLIER_MIN) : value
}
const setEarlier = value => {
  schedule.value.productionDaysBefore = value === null ? null : Math.max(value, EARLIER_MIN)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(windowCopy.value)), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          "model-value": arrival.value.preset,
          label: windowCopy.value.title,
          options: _unref(presetOptions),
          "onUpdate:modelValue": pickPreset
        }, null, 8, ["model-value", "label", "options"]),
        (arrival.value.preset === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(SelectInput, {
                modelValue: arrival.value.start,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((arrival.value.start) = $event)),
                name: "From",
                options: _unref(QUARTER_HOURS)
              }, null, 8, ["modelValue", "options"]),
              _createVNode(SelectInput, {
                modelValue: arrival.value.end,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((arrival.value.end) = $event)),
                name: "To",
                options: _unref(QUARTER_HOURS)
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('production', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(PillRadioGroup, {
            "model-value": productionMode.value,
            label: "Production day",
            options: _unref(PRODUCTION_OPTIONS),
            "onUpdate:modelValue": pickProduction
          }, null, 8, ["model-value", "options"]),
          (productionMode.value === 'earlier')
            ? (_openBlock(), _createBlock(NumberStepper, {
                key: 0,
                "model-value": schedule.value.productionDaysBefore,
                name: "Days before",
                min: EARLIER_MIN,
                max: _unref(MAX_PRODUCTION_DAYS_BEFORE),
                "onUpdate:modelValue": setEarlier
              }, null, 8, ["model-value", "max"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TextWithHint, {
          text: _unref(PRODUCTION_NOTE),
          label: _unref(DROP_HINT_LABEL),
          hint: dropHint.value
        }, null, 8, ["text", "label", "hint"])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}